import { ButtonVariant, RadiusEnum, IMENU_NAV, MapTheme } from './enums';
import Sidebar from '../../icons/Images/Skeletons/Menu/Sidebar.png';
import Topbar from '../../icons/Images/Skeletons/Menu/TopBar.png';

export const BUTTON_VARIANTS = [ButtonVariant.PRIMARY, ButtonVariant.SECONDARY, ButtonVariant.TERTIARY];

export const ButtonCornerVariant = {
  SHARP: 0,
  SOFT: 14,
  ROUNDED: 49,
};
export const CORNER_VARIANTS = {
  [RadiusEnum.SHARP]: 0,
  [RadiusEnum.SOFT]: 14,
};

export const MAP_THEMES = [MapTheme.LIGHT, MapTheme.DARK];
export const ASPECT_RATIO = {
  IMAGE_GALLERY: {
    VARIANT1: ['1 / 1'],
    VARIANT2: ['3 / 4'],
    VARIANT3: ['1 / 1'],
  },
  HERO: {
    VARIANT1: ['16/9', '4/3', '1/1', '3/2', '5/2', '17/9'],
    VARIANT2: ['16/9', '4/3', '1/1', '3/2', '5/2', '17/9'],
  },
  ABOUT_US: {
    VARIANT1: ['1/1'],
    VARIANT2: ['16/9', '4/3', '1/1', '3/2', '5/2', '17/9'],
  },
  CALL_TO_ACTION: {
    VARIANT1: ['13/8'],
  },
};

export const HERO_SECTION = {
  DEFAULT: ['5/2'],
  FULL_SCREEN_HEIGHT: ['17/9'],
};

export const HERO_SECTION_HEIGHTS = {
  DEFAULT: 'DEFAULT',
  FULL_SCREEN_HEIGHT: 'FULL_SCREEN_HEIGHT',
};

export const ACTIVE_BACKGROUND = {
  STILL_IMAGE: 'STILL_IMAGE',
  VIDEO: 'VIDEO',
  CAROUSEL: 'CAROUSEL',
};

export const MenuNavVariants = [
  { skeleton: Sidebar, value: IMENU_NAV.SIDEBAR },
  { skeleton: Topbar, value: IMENU_NAV.TOPBAR },
];

export const BUILDER_EDITOR_WRAPPER_ID = 'editor-wrapper';
export const BUILDER_EDITOR_ELEMENT_ID = 'editor';
